export var GeometryType;
(function (GeometryType) {
    /**
     * Draw single points.
     */
    GeometryType[GeometryType["POINTS"] = 0] = "POINTS";
    /**
     * Draw lines. Each vertex connects to the one after it.
     */
    GeometryType[GeometryType["LINES"] = 1] = "LINES";
    /**
     * Draw lines. Each set of two vertices is treated as a separate line segment.
     */
    GeometryType[GeometryType["LINE_LOOP"] = 2] = "LINE_LOOP";
    /**
     * Draw a connected group of line segments from the first vertex to the last.
     */
    GeometryType[GeometryType["LINE_STRIP"] = 3] = "LINE_STRIP";
    /**
     * Draw triangles. Each set of three vertices creates a separate triangle.
     */
    GeometryType[GeometryType["TRIANGLES"] = 4] = "TRIANGLES";
    /**
     * Draw a connected strip of triangles.
     */
    GeometryType[GeometryType["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    /**
     * Draw a connected group of triangles. Each vertex connects to the previous and the first vertex in the fan.
     */
    GeometryType[GeometryType["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})(GeometryType || (GeometryType = {}));
export var VertexFormatType;
(function (VertexFormatType) {
    VertexFormatType[VertexFormatType["Float16"] = 0] = "Float16";
    VertexFormatType[VertexFormatType["Float32"] = 1] = "Float32";
    VertexFormatType[VertexFormatType["Int8"] = 2] = "Int8";
    VertexFormatType[VertexFormatType["Int16"] = 3] = "Int16";
    VertexFormatType[VertexFormatType["Int32"] = 4] = "Int32";
    VertexFormatType[VertexFormatType["UInt8"] = 5] = "UInt8";
    VertexFormatType[VertexFormatType["UInt16"] = 6] = "UInt16";
    VertexFormatType[VertexFormatType["UInt32"] = 7] = "UInt32";
})(VertexFormatType || (VertexFormatType = {}));
export var IndexFormatType;
(function (IndexFormatType) {
    IndexFormatType[IndexFormatType["None"] = -1] = "None";
    IndexFormatType[IndexFormatType["UInt8"] = 0] = "UInt8";
    IndexFormatType[IndexFormatType["UInt16"] = 1] = "UInt16";
    IndexFormatType[IndexFormatType["UInt32"] = 2] = "UInt32";
})(IndexFormatType || (IndexFormatType = {}));
// BINORMAL[n]	Binormal	float4
// BLENDINDICES[n]	混合索引	uint
// BLENDWEIGHT[n]	混合权重	FLOAT
// COLOR[n]	漫射和反射颜色	float4
// NORMAL[n]	法向矢量	float4
// POSITION[n]	对象空间中的顶点位置。	float4
// POSITIONT	变换的顶点位置。	float4
// PSIZE[n]	点大小	FLOAT
// TANGENT[n]	正切	float4
// TEXCOORD[n]	纹理坐标	float4
// POSITION_BS[n]	Blend Shape 空间中的顶点位置	float4
// NORMAL_BS[n]	Blend Shape 空间中的法向矢量	float4
// TANGENT_BS[n]	Blend Shape 空间中的正切矢量	float4
export var VertexBufferSemantic;
(function (VertexBufferSemantic) {
    VertexBufferSemantic["Position"] = "POSITION";
    VertexBufferSemantic["Uv"] = "TEXCOORD0";
    VertexBufferSemantic["Uv2"] = "TEXCOORD1";
    VertexBufferSemantic["Normal"] = "NORMAL";
    VertexBufferSemantic["Tangent"] = "TANGENT";
    VertexBufferSemantic["Color"] = "COLOR";
    VertexBufferSemantic["Joints"] = "JOINTS";
    VertexBufferSemantic["Weights"] = "WEIGHTS";
    //
    VertexBufferSemantic["PositionBS0"] = "POSITION_BS0";
    VertexBufferSemantic["PositionBS1"] = "POSITION_BS1";
    VertexBufferSemantic["PositionBS2"] = "POSITION_BS2";
    VertexBufferSemantic["PositionBS3"] = "POSITION_BS3";
    VertexBufferSemantic["PositionBS4"] = "POSITION_BS4";
    VertexBufferSemantic["PositionBS5"] = "POSITION_BS5";
    VertexBufferSemantic["PositionBS6"] = "POSITION_BS6";
    VertexBufferSemantic["PositionBS7"] = "POSITION_BS7";
    VertexBufferSemantic["NormalBS0"] = "NORMAL_BS0";
    VertexBufferSemantic["NormalBS1"] = "NORMAL_BS1";
    VertexBufferSemantic["NormalBS2"] = "NORMAL_BS2";
    VertexBufferSemantic["NormalBS3"] = "NORMAL_BS3";
    VertexBufferSemantic["TangentBS0"] = "TANGENT_BS0";
    VertexBufferSemantic["TangentBS1"] = "TANGENT_BS1";
    VertexBufferSemantic["TangentBS2"] = "TANGENT_BS2";
    VertexBufferSemantic["TangentBS3"] = "TANGENT_BS3";
})(VertexBufferSemantic || (VertexBufferSemantic = {}));
